import React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { clearfix } from 'styles/clearfix'
import { column } from 'styles/column'
import Button from 'components/button'

const ListItemType = {
  id: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  wasPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired,
}

const SimilarProducts = ({ similarProducts }) => {
  return (
    <List>
      {similarProducts.map((product, key) => (
        <ListItem {...product} key={key} />
      ))}
    </List>
  )
}

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  @media (min-width: 800px) {
    ${clearfix}
  }
`

SimilarProducts.propTypes = {
  similarProducts: PropTypes.arrayOf(PropTypes.shape(ListItemType)).isRequired,
}

const ListItem = ({ image, imageAlt, link, price, subtitle, title, wasPrice }) => {
  return (
    <StyledListItem>
      <Link to={link}>
        <ImageContainer>
          <img src={image} alt={imageAlt} loading='lazy' />
        </ImageContainer>
        <Title>{title}</Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
        <div>
          {price && (
            <Price reducedPrice={wasPrice}>
              {Number(price).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 0,
              })}
            </Price>
          )}
          {wasPrice && (
            <WasPrice>
              {Number(wasPrice).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 0,
              })}
            </WasPrice>
          )}
        </div>
        <StyledButton>View Product</StyledButton>
      </Link>
    </StyledListItem>
  )
}

ListItem.propTypes = ListItemType

ListItem.defaultProps = {
  subtitle: '',
}

const StyledListItem = styled.li`
  margin-bottom: 15px;
  padding: 0;
  text-align: center;

  > a {
    background-color: #fff;
    border: 1px solid #d7d7d7;
    box-shadow: none;
    color: #000;
    display: block;
    padding: 20px;
    text-decoration: none;
    transition: box-shadow 0.2s;

    :hover,
    :focus {
      box-shadow: 0 0 25px rgba(0, 0, 0, 0.1);
    }
  }

  @media (min-width: 800px) {
    ${column('1/3')}
  }
`

const ImageContainer = styled.div`
  background-color: #fff;
  display: block;
  height: 0px;
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
  width: auto;

  img {
    display: block;
    height: auto;
    left: 50%;
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: auto !important;
  }
`

const Title = styled.h3`
  font-size: 1.5em;
  font-weight: bold;
  line-height: 1;
  margin: 10px 0 0;
  max-width: 100%;
  padding: 0;
  text-transform: none;
  width: 100%;
`

const Subtitle = styled.span`
  display: block;
  font-size: 0.85em;
`

const Price = styled.span`
  color: ${props => (props.reducedPrice ? props.theme.color.r300 : '#000')};
  display: inline-block;
  font-size: 1.75em;
  font-weight: bold;
  margin-right: 10px;
`

const WasPrice = styled.span`
  color: #7d7d7d;
  display: inline-block;
  font-size: 1.1em;
  font-weight: 400;
  text-decoration: line-through;
`

const StyledButton = styled(Button)`
  margin-top: 10px;
`

export default SimilarProducts
